import { PropsWithChildren, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons'
import { Breadcrumb, Button, Divider, Layout } from 'antd'

import { useAuth, useLeftDrawer, useNavigation } from '@/hooks'
import { splitPath } from '@/utils/Navigation'

import { LeftDrawer } from '../templates'

const { Header, Content } = Layout

export const ContentLayout = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation()
  const navigation = useNavigation()
  const { isHidden, toggle } = useLeftDrawer()
  const { isAuthenticated, logout } = useAuth()

  useEffect(() => {
    if (!isAuthenticated && navigation.currentPath !== '/login') {
      navigation.goTo('login', { state: { prevPage: navigation.currentPath } })
    }
  }, [isAuthenticated])

  return (
    <Layout className="h-screen">
      <LeftDrawer />
      <Layout>
        <Header className="flex flex-row items-center justify-between bg-primary px-4 py-0">
          <Button
            type="text"
            className="h-16 w-16 text-white"
            icon={isHidden ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={toggle}
          />
          <Button type="primary" title={t('Logout')} onClick={logout}>
            {t('Logout')}
          </Button>
        </Header>
        <Content className="p-6">
          <BreadCrumb />
          <Divider />
          {children}
        </Content>
      </Layout>
    </Layout>
  )
}

const BreadCrumb = () => {
  const { t } = useTranslation()
  const navigation = useNavigation()

  const paths = useMemo(() => {
    return splitPath(navigation.currentPath)
  }, [navigation.currentPath])

  return (
    <Breadcrumb
      items={paths.map((path, index) => ({
        href: index === paths.length - 1 ? undefined : '/#' + path,
        title: t(path, ''),
      }))}
      className="text-black"
    />
  )
}
